import { render, staticRenderFns } from "./ChartRevenu.vue?vue&type=template&id=c452dc9e&scoped=true&"
import script from "./ChartRevenu.vue?vue&type=script&lang=js&"
export * from "./ChartRevenu.vue?vue&type=script&lang=js&"
import style0 from "./ChartRevenu.vue?vue&type=style&index=0&id=c452dc9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c452dc9e",
  null
  
)

export default component.exports